'use strict';

var React = require('react');

var SvgCursorBannerIcon = function SvgCursorBannerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.25v3.75c0 .414.336.75.75.75s.75-.336.75-.75v-3.75c0-2.071-1.679-3.75-3.75-3.75h-5.5c-2.071 0-3.75 1.679-3.75 3.75v5.5c0 2.071 1.679 3.75 3.75 3.75h3.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.75c-1.243 0-2.25-1.007-2.25-2.25v-5.5c0-1.243 1.007-2.25 2.25-2.25h5.5c1.243 0 2.25 1.007 2.25 2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.625c0-.345-.28-.625-.625-.625h-6.375c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h3.165c.484 0 .898-.346.984-.821l.202-1.108c.086-.475.5-.821.984-.821h1.04c.345 0 .625-.28.625-.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.69 12.084c-.17-.042-.35.008-.474.132s-.174.304-.132.474l1.122 4.51c.043.176.177.314.351.362.174.048.36-.001.487-.128l1.165-1.165.84.841c.196.196.512.196.708 0l.353-.353c.195-.196.195-.512 0-.707l-.84-.841 1.163-1.165c.128-.127.177-.313.129-.487-.049-.174-.187-.308-.361-.351l-4.51-1.122Z"
  }));
};
SvgCursorBannerIcon.displayName = "CursorBannerIcon";

exports.SvgCursorBannerIcon = SvgCursorBannerIcon;
